module.exports = __webpack_public_path__ + "static/other/diner.a986b2ff.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/diner.json
// module id = 2325
// module chunks = 0